export const ON_SUCCESS = 'ON_SUCCESS';
export const ON_FAIL_REISSUE = 'ON_FAIL_REISSUE';
export const ON_FAIL_REISSUE_GENERAL = 'ON_FAIL_REISSUE_GENERAL';
export const ON_FAIL_REISSUE_NONPAYMENT = 'ON_FAIL_REISSUE_NONPAYMENT';
export const ON_FAIL_REISSUE_VARIATION = 'ON_FAIL_REISSUE_VARIATION';
export const ON_WARNING_CONFIRMATION = 'ON_WARNING_CONFIRMATION';
export const ON_CANCEL_WARNING_CONFIRMATION = 'ON_CANCEL_WARNING_CONFIRMATION';
export const ON_RESET_REISSUE = 'ON_RESET_REISSUE';
export const LOADING = 'LOADING_REISSUE';

export const ON_EMISSION_PENDING_VERIFICATION = 'ON_EMISSION_PENDING_VERIFICATION';
export const ON_FARE_UNAVAILABLE = 'ON_FARE_UNAVAILABLE';